const services = [
    {
        id: 1,
        name: "Myolift",
        description: "The professional only natural lift with true microcurrent. Lifting muscles in face and neck, working all 32 muscles. Sculpting Treatment for face and neck. No downtime."
    },
    {
        id: 2,
        name: "The Eye Bright Treatment",
        description: "Smooth and brighten the eye area. Helps the delciate skin around the eyes and eye lids using a gentle solution made for this area to exfoliate and strengthen. Minimum to no downtime."
    },
    {
        id: 3,
        name: "Skin Smoothing and Brightening",
        description: "Smooth and brighten skin with a light to medium exfoliation. Typically done on face, chest or hands."
    },
    {
        id: 4,
        name: "European Deluxe Facial",
        description: "Customized to your skin needs. Relaxation combined with medical grade and natural treatments make this facial unique."
    },
    {
        id: 5,
        name: "Dermaplaning",
        description: "Great for prepping the skin for a deeper facial or deeper peel. Removes peach fuzz while renewing the skin."
    },
    {
        id: 6,
        name: "Ionic Detox Foot Spa",
        description: "The holistic healing benefits may include decreased joint stiffness, muscle spasm relief, increased blood flow, pain relief and reduced inflammation, aid in process of weight loss and improve immune system and overall health."
    },
    {
        id: 7,
        name: "Facial Cupping",
        description: "Gentle suction promotes increased blood circulation which may help relieve muscle tension, promote cell repair and aid in regeneration. Improves complexion and diminishes fine lines."
    },
    // {
    //     id: 8,
    //     name: "Cupping for Cellulite",
    //     description: "Increased blood circulation and creates new blood vessels and connective tissues. Drains fluids and toxins from your body."
    // },
    {
        id: 9,
        name: "Detoxifying Seaweed Body Wrap",
        description: "Detoxify and flush out toxins from the body. Seaweed is rich in minerals and vitamins that help to nourish and hydrate the skin. May also help to improve circulation by stimulating blood flow and reduce the appearance of cellulite."
    },
    {
        id: 10,
        name: "The Ultimate Tech Lift and Glow Treatment",
        description: "A 7-in-1 facial skincare machine treatment to enhance your glow. Uses a multifunctional device that combines seven different professional aesthetic technologies into a single system to cleanse, hydrate, and rejuvenate, leaving you with a lift and glow. Red light therapy, ultrasound, oxygen infusion, aqua facial, rf, and more."
    }
];

export default services;